import React from 'react'
import { breakpoints } from 'ui/acro'
import Carousel from 'components_v2/Home/SignedIn/common/components/Carousel/Carousel'
import { ClassCard } from 'components_v1/SchemaSectionRenderer/common/components'
import { useUserContext } from 'context'

const ClassResultsCarousel = ({ data }) => {
  const { user } = useUserContext() || {}
  const classesData = data && data.classes.top
  const transformedData = classesData.reduce((acc, item) => {
    return [
      ...acc,
      {
        id: item.id,
        isFevIcon: false,
        title: item.title,
        humanDuration: item.humanDuration,
        videoThumbnail: item.thumbnailImage,
        plan: {
          title: item.series,
          difficultyLevel: item.difficultyLevel,
          primaryCategory: {
            title: item.category
          },
          subcategory: {
            title: item.subcategory
          },
          coaches: item.coaches?.reduce((acc, coach) => {
            return [
              ...acc,
              {
                firstName: coach,
                lastName: ''
              }
            ]
          }, [])
        },
        planEntryUrl: item.url,
        availabilityGating: item?.availabilityGating,
        membershipTier: user?.membershipTier
      }
    ]
  }, [])

  return (
    <Carousel
      card={ClassCard}
      carouselTitle={'ClassesTopResults'}
      data={transformedData}
      mx={['16px', '16px', '16px', '0px']}
      breakpoints={{
        0: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        320: {
          slidesPerView: 1.7,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        375: {
          slidesPerView: 1.7,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[1]]: {
          slidesPerView: 2.7,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          slidesPerView: 2.7,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[2]]: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }}
    />
  )
}

export default ClassResultsCarousel
